module.exports = {
	"Announcement": {
		"Know More": "Find out more"
	},
	"Appointment": {
		"Conditions": "By clicking on “Confirm” you confirm you have read the privacy policy and consent to the processing of your personal data by %(brand)s in the conditions set forth in the privacy policy to answer your request.",
		"Confirmation": "Your request for an in-store appointment for personalized assistance with one of our advisers has been registered. You will receive email confirmation shortly.",
		"Description": "Dior invites you to meet with one of its advisers in store for personalised help.",
		"Get an appointment": "Make an appointment",
		"Motives": "Motifs",
		"Universes": "Product range"
	},
	"DiorMap": {
		"Search in this area": "Search in this area"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Result",
			"other": "%(count)s Results",
			"zero": "%(count)s Result"
		},
		"Refine": "Refine",
		"RefineAria": "Refine search with the checkboxes below",
		"Are you looking for?": "Are you searching for a boutique relating to Women’s Fashion, Men's Fashion, Baby, Jewellery or Watch ranges?"
	},
	"Footer": {
		"Download the applications": "Download the applications",
		"Language": "Language",
		"Newsletter": "e.g. Christian@dior.fr",
		"Ok": "OK",
		"Subscribe to newsletter": "Sign up for the Newsletter"
	},
	"Form": {
		"All fields are mandatory": "All fields are required",
		"Civility": "Title",
		"Comments": "Comments",
		"Conditions": "Please tick the box above if you wish to receive an email confirmation from %(brand)s. You have the right to access, make corrections to, delete and oppose the use of your personal data, which you can exercise by writing to contact@dior.com",
		"Date": "Preferred date ",
		"Email": "Email address",
		"Hour": "Preferred time",
		"Invalid E-mail address": "Invalid E-mail address",
		"Mr": "Mr",
		"Mrs": "Mrs",
		"Name": "Last name",
		"Phone": "Telephone",
		"Required fields": "Required fields",
		"Submit": "Confirm",
		"Surname": "First name"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Dior Boutiques near you: haute couture, fragrances, leather goods",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Arrival",
		"Departure": "Departure",
		"Details": "Details",
		"Error": "Sorry, we were unable to obtain the requested directions. Please change the departure address and/or method of transport and try again.",
		"Follow the itinerary": "Follow directions",
		"Itinerary": "Directions",
		"modeBICYCLING": "Switch to bicycling",
		"modeDRIVING": "Switch to driving",
		"modeTRANSIT": "Switch to transit",
		"modeWALKING": "Switch to walking",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Please use your phone in portrait mode"
	},
	"NavMobile": {
		"Home": "Home"
	},
	"Newsletter": {
		"Dior Newsletter": "Dior Newsletter",
		"Fashion and accessories": "Fashion & Accessories",
		"I wish to receive the %(newsletter)s newsletter": "I wish to receive %(newsletter)s news",
		"Newsletter Confirmation": "You have successfully signed up for the newsletter",
		"Perfume and beauty": "Fragrance & Beauty",
		"Receive our newsletter": "Receive our newsletter",
		"Your universes": "Your areas of interest"
	},
	"ResultsBlock": {
		"Dior boutiques": "Dior boutiques",
		"Too far": "Too many results, please refine your search by choosing a smaller search area.",
		"No result": "No shop could be found",
		"Other shops": "Other boutiques",
		"Results": "Search results",
		"Fewer results, zoom in": "Fewer results, zoom in",
		"More results, zoom out": "More results, zoom out",
		"Fewer results": "Fewer results",
		"More results": "More results"
	},
	"SearchBlock": {
		"Geolocation": "Use geolocation to find stores near you",
		"Search": "Search"
	},
	"Share": {
		"Conditions": "By clicking on “Confirm” you confirm you have read the privacy policy and consent to the processing of your personal data by %(brand)s in the conditions set forth in the privacy policy to answer your request. If you tick the appropriate box, you also consent to the processing of your personal data by Christian Dior Couture for direct marketing, which my be tailored based on the personal data we know about you and your preferences.",
		"Recipient": "Recipient",
		"Share Confirmation": "The details for your boutique have been sent",
		"Share this shop": "Share the store details",
		"Your favorite shop": "Preferred boutique"
	},
	"ShopBlock": {
		"Closed": "Closed",
		"Closed today": "Closed today",
		"Directions": "Directions",
		"DirectionsAria": "Directions to %(shopName)s",
		"Make an appointment": "Make an appointment",
		"Open": "Open",
		"Opening time": "Opening hours",
		"OpeningAria": "More information on the Opening hours",
		"ResultNumber": "Result number %(number)s",
		"Services": "Services",
		"ServicesAria": "More information on the Services",
		"Share": "Share",
		"Special hours": "Special hours",
		"Today until %(hour)s": "Today until %(hour)s",
		"Universes": "Product range",
		"UniversesAria": "More information on the related Universes",
		"and": "and",
		"from": "from",
		"publicHolidays": "The boutique is probably closed",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/en_gb/translations.json
// module id = 858
// module chunks = 0